import {Component, Input, OnInit} from '@angular/core';
import {LoadingController, ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {CustomerResourceService} from '../../services/database/resource/customer-resource.service';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {FuelValues} from '../../definitions/fuel-values';
import {DocumentTypes} from '../../definitions/document-types';
import {TestConnectionService} from '../../services/test-connection.service';
import {GeneralService} from '../../services/general.service';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {GetLiveDetailLinesForCustomerService} from '../../services/get-live-detail-lines-for-customer.service';
import {FuelLevelModel} from '../../models/fuel-level.model';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {CustomerModel} from '../../models/customer.model';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';

@Component({
    selector: 'app-equip-list-return',
    templateUrl: './equip-list-return.page.html',
    styleUrls: ['./equip-list-return.page.scss'],
})
export class EquipListReturnPage implements OnInit {
    @Input() document: DocumentModel;
    detailLinesList: any[] = [];
    packageLinesList: any[] = [];
    detailLinesDTO: DetaillineDTOModel[];
    queryText = '';
    lightColor = '#F4F5F7';
    darkColor = '#CACCE0';
    loading: any;
    fuelValues: FuelLevelModel[];
    loadingOverlay: any;
    mobileConfig: MobileConfigurationModel;

    constructor(private customerRes: CustomerResourceService,
                private modalController: ModalController,
                private loadingController: LoadingController,
                private fuelValuesDefinition: FuelValues,
                private docTypes: DocumentTypes,
                private testConnection: TestConnectionService,
                private generalService: GeneralService,
                private refreshDataBase: RefreshdatabaseService,
                private getLiveDetailLinesForCustService: GetLiveDetailLinesForCustomerService,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames) {
    }

    ngOnInit() {
        this.fuelValues = this.fuelValuesDefinition.FUEL_VALUES;
        this.mobileConfig = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION);
        // await this.loadingOverlaySpinner();
        // await this.updateDetailLines(null);
        this.fetchContracts();
        this.checkLinePresent();
        // await this.loadingOverlay.dismiss();
        // if (this.document.detailLines.length > 0) {
        //     await this.detailLinesService(this.document.detailLines);
        //     await this.checkLinePresent();
        // } else {
        //     await this.loadingOverlaySpinner();
        //     await this.updateDetailLines(null);
        //     await this.checkLinePresent();
        //     await this.loadingOverlay.dismiss();
        //     // await this.loadingFetchingDetailLines();
        // }
    }

    async loadingOverlaySpinner() {
        await this.loadingController.create({
            message: 'Loading...',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            spinner: 'bubbles'
        }).then((overlay) => {
            this.loadingOverlay = overlay;
            this.loadingOverlay.present();
        });
    }

    checkQty(event, dtLine: any) {
        console.log(event.detail.value);
        console.log(dtLine);
        if (dtLine.line.qty < event.detail.value) {
            this.generalService.createToast('Quantity invalid');
            dtLine.line.qty = dtLine.line.qty;
        }
    }

    async updateDetailLines(event) {
        try {
            await this.testConnection.pingServer();
            if (this.document.customer && this.document.customer.id) {
                await this.getLiveDetailLinesForCustService.fetchLiveDetailLinesForCust(this.document.customer.id);
            } else {
                // TODO Check the issue for locations
                await this.refreshDataBase.refreshLiveContractsResource();
            }
            this.fetchContracts();
            if (event) {
                await event.target.complete();
            }
        } catch (e) {
            console.log(e);
            this.fetchContracts();
            this.generalService.createToast('No connection to the server');
            if (event) {
                await event.target.complete();
            }
        }
    }

    fetchContracts() {
        let liveDetailLines = this.stateManager.getCollection('livedetaillines') as DetaillineDTOModel[];
        console.log(liveDetailLines);
        liveDetailLines = liveDetailLines.filter(line => {
            return !line.plu;
        });
        if (liveDetailLines && liveDetailLines.length > 0 && this.document.customer && this.document.customer.cod) {
            liveDetailLines = liveDetailLines.filter(liveLine => {
                return this.document.customer && this.document.customer.id ?
                    (liveLine.custId === this.document.customer.id && !liveLine.plu) : !liveLine.plu;
            });
            if (this.document.site.id) {
                liveDetailLines = liveDetailLines.filter(c => {
                    return c.site === this.document.site.id;
                });
            }
            console.log(liveDetailLines);
        }
        this.detailLinesService(liveDetailLines);
    }

    detailLinesService(detailLines: DetaillineDTOModel[]) {
        this.detailLinesList = [];
        this.packageLinesList = [];
        if (detailLines.length > 0) {
            for (const line of detailLines) {
                if (line.pdesc && line.packageName && line.packageSeq) {
                    this.checkPackage(line);
                } else {
                    this.detailLinesList.push({'line': line, 'isChecked': false});
                }
            }
        }
        console.log(this.detailLinesList);
    }

    checkPackage(line: DetaillineDTOModel) {
        // This method will get the details lines and check if there's a package item
        // if so it will add the Head of the package to the detailLinesList and the
        // rest of the package to the packageLinesList array
        if (line.pdesc === line.packageName) {
            this.detailLinesList.push({'line': line, 'isChecked': false});
        } else {
            this.packageLinesList.push({'line': line, 'isChecked': false});
        }
    }

    cancel() {
        this.modalController.dismiss();
    }

    addDetailLines() {
        this.detailLinesDTO = [];
        for (const line of this.detailLinesList) {
            if (line.isChecked) {
                if (line.line.custId === this.document.customer.id) {
                    this.detailLinesDTO.push(line.line);
                }
            }
        }
        for (const line of this.packageLinesList) {
            if (line.isChecked) {
                this.detailLinesDTO.push(line.line);
            }
        }
        this.modalController.dismiss(this.detailLinesDTO);
    }

    checkLinePresent() {
        if (this.document.detailLines.length > 0) {
            for (const line of this.detailLinesList) {
                for (const docLine of this.document.detailLines) {
                    if (docLine.reg === '') {
                        docLine.reg = null;
                    }
                    if (line.line.pdesc === docLine.pdesc
                        && line.line.reg === docLine.reg
                        && line.line.contractDocumentNumber === docLine.contractDocumentNumber) {
                        line.line = JSON.parse( JSON.stringify(docLine) ) ;
                        line.isChecked = true;
                        line.line.qty = line.line.requiredQty;

                        if( this.document.customer && this.document.customer.id ){
                            line.line.custId = this.document.customer.id;
                        }
                        

                        if (line.line.packageSeq) {
                            this.markAccessories(true, line.line);
                        }
                    }
                }
            }
        }
        console.log(this.detailLinesList);
    }

    markAccessories(isChecked: boolean, line: DetaillineDTOModel) {
        // Method to check/uncheck accessories when the main product is selected
        if (line.packageName) {
            for (const dtLine of this.packageLinesList) {
                if (dtLine.line.contractDocumentNumber === line.contractDocumentNumber
                    && dtLine.line.packageSeq === line.packageSeq
                    && dtLine.line.packageName === line.packageName) {
                    dtLine.isChecked = isChecked;
                }
            }
        }
    }

    fuelSelectChanged(item: any) {
        if (this.checkDetailLineStatus(item.line)) {
            item.isChecked = true;
        }
    }

    checkDetailLineStatus(line: DetaillineDTOModel) {
        if (line.status === 9
            && this.document.documentType !== this.docTypes.RETURN
            && this.document.documentType !== this.docTypes.SIGNDOCUMENT) {
            this.generalService.createToast('Item is already Offhired');
            return false;
        } else {
            return true;
        }
    }

    selectLine(item: any) {
        console.log(this.document.customer);
        if (!this.document.customer || !this.document.customer.cod) {
            this.assignCustomer(item.line);
        }
        if (this.checkDetailLineStatus(item.line)) {
            item.isChecked = !item.isChecked;
        }
        console.log(item);
    }

    assignCustomer(equipment: DetaillineDTOModel) {
        console.log(equipment);
        const customers = this.stateManager.getCollection('customer') as CustomerModel[];
        this.document.customer = customers.find(cust => {
            return cust.id === equipment.custId;
        });
        console.log(this.document.customer);
        this.detailLinesList = this.detailLinesList.filter(item => {
            return item.line.custId === this.document.customer.id;
        });
    }

    compareFuelLevel(o1: FuelLevelModel, o2: FuelLevelModel) {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    }
}
